// import external dependencies
import 'jquery';
import 'js-cookie';
import 'owl.carousel';
// import 'masonry-layout';
import 'lightgallery';

// Import everything from autoload
import './autoload/_bootstrap.js'

import { library, dom } from '@fortawesome/fontawesome-svg-core';

import { faCircleArrowLeft } from '@fortawesome/free-solid-svg-icons';

// add the imported icons to the library
library.add(faCircleArrowLeft);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
